import React, { useMemo } from 'react'
import './StoneCollectionPanel.css'
import PMO from '../../Asset/Image/ShapeImage/PMO Shape Collection.png'

const collectionImages = {
    'PMO': PMO
}

function StoneCollectionPanel({ ShapMastIsWeb = [], SearchResultData, onCollectionClick }) {
    const collections = useMemo(() => {
        if (!ShapMastIsWeb || !Array.isArray(ShapMastIsWeb)) return []

        const getStonePieces = stone => {
            const pcsValue = stone?.PCS ?? stone?.I_PCS ?? stone?.PCS_QTY ?? stone?.QTY ?? stone?.Qty
            const parsed = Number(pcsValue)
            return Number.isFinite(parsed) && parsed > 0 ? parsed : 1
        }

        // Group shapes by collection
        const grouped = {}
        ShapMastIsWeb.forEach(shape => {
            const collection = shape.S_COLLECTION
            if (!collection || typeof collection !== 'string' || collection.trim() === '') return

            if (!grouped[collection]) {
                grouped[collection] = {
                    name: collection,
                    description: collection,
                    shapes: [],
                    totalPcs: 0
                }
            }
            grouped[collection].shapes.push(shape)
        })

        // Calculate total PCS for each collection
        Object.keys(grouped).forEach(collectionName => {
            const collection = grouped[collectionName]
            const shapeCodes = collection.shapes.map(s => s.S_CODE)

            const searchArray = Array.isArray(SearchResultData) ? SearchResultData : []
            const matchingStones = searchArray.filter(stone =>
                shapeCodes.includes(stone.S_CODE)
            )

            collection.totalPcs = matchingStones.reduce((sum, stone) => {
                return sum + getStonePieces(stone)
            }, 0)
        })

        return Object.values(grouped).sort((a, b) => b.totalPcs - a.totalPcs)
    }, [ShapMastIsWeb, SearchResultData])

    return (
        <div className='stone-collection-panel'>
            <div className='collection-header'>
                <h5>Our Collection</h5>
            </div>

            <div className='collection-list'>
                {collections.length > 0 ? (
                    collections.map((collection, idx) => (
                        <div
                            key={idx}
                            className='collection-card'
                            onClick={() => onCollectionClick && onCollectionClick(collection.shapes.map(s => s.S_CODE))}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className='collection-icon'>
                                {collectionImages[collection.name] ? (
                                    <img src={collectionImages[collection.name]} alt={collection.name} style={{ width: '40px', height: '40px', objectFit: 'contain' }} />
                                ) : (
                                    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <path d='M20 2L35 15V30L20 38L5 30V15L20 2Z' stroke='#667bc6' strokeWidth='2' fill='none' />
                                    </svg>
                                )}
                            </div>
                            <div className='collection-content'>
                                <h6 className='collection-name'>{collection.name}</h6>
                                <p className='collection-desc'>{collection.description}</p>
                            </div>
                            <div className='collection-pcs'>
                                <span className='pcs-count'>{collection.totalPcs}</span>
                                <span className='pcs-label'>Pcs in Stock</span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className='empty-state'>
                        <p>No collections available</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default StoneCollectionPanel
